module.exports = {
    sys:{
        search: 'Search',
        print: 'Print',
        all: 'All',
        total: 'total ',
        record: ' records',
        fullscreen: 'Fullscreen',
        exitFullscreen: 'Exit fullscreen',
        noData: 'No data',
        retry: 'Retry',
        notLogin: 'Not login',
        toLogin: 'Go to login',
        notice: 'Notice',
        warning: 'Warning',
        error: 'Error',
        clickTooFast: 'Click too fast, please try again later!',
        saveSuccess: 'Save successfully',
        unlimited: 'Unlimited',
        errReason: 'Error reason',
        test: 'Test',
        reload: 'Reload',
        username: 'Username',
        sysError: 'System error, Please try again later!',
        networkError: 'Network error, Please try again later!',
        download: 'Download'
    },
    exam:{
        exam: 'Exam',
        simExam: 'Simulation',
        revisionBook: 'Revison books',
        noAnswer: '(Not submitted)',
        point: 'Point',
        selectPaper:'Select paper',
        selectKnowleagePoint: 'Select knowleage point',
        selectQuestionType: 'Select question type',
        inputKW: 'Input a keyword',
        analysis: 'Analysis',
        answer: 'Answer',
        wrong: 'Wrong',
        right: 'Right',
        answerArex: 'Answer Area',
        viewAnswer: 'View Solution',
        viewTemplate: 'View Template',
        viewTestCase: 'View case',
        paperDesc: 'Paper Info',
        timeLimit: 'Time Limit',
        spendTime: 'Spend time',
        remainingTime: 'Time remaining',
        remainingHalf: 'Half the time',
        remaining5min: '5 minutes remaining',
        remaining1min: '1 minute remaining',
        minute: 'Minute',
        totalScore: 'Total score',
        gotScore: 'Got score',
        save: 'Save',
        submit: 'Submit',
        submitProject: 'Submit your project',
        student: 'Student',
        tips: 'Tips:',
        tips1:'1.Blue：submited',
        tips2:'2.White：not submited',
        points: 'Points',
        questionSection: '(Total{total}, Points each{questionScore}, Points total:{totalScore}）',
        questionSeq: 'Question {index}',
        questionIndex: 'Question {index}  ({points} Points)',
        modifyProject: 'Modify project',
        startProject: 'Start programming',
        viewQuestionStem: 'View question',
        deviceTest: 'Device check',
        deviceRequirement: 'Device requirement',
        camera: 'Camera',
        cameraArea: 'Camera check area',
        cameraPass: 'Camera check pass',
        cameraNotSupport: 'Camera not support',
        cameraNotPass: 'The camera and microphone fail to be enabled. Please check the devices. ',
        mic: 'Micphonme',
        requireMic: 'Please turn on the camera and microphone to enter',
        screenRecord: 'Screen recorder',
        screenRecorderArea: 'Screen recorder check area',
        requireScreenRecorder: 'Please enable screen recording to enter',
        screenRecorderPass: 'Screen recorder check pass',
        screenRecorderNotPass: 'Failed to enable screen recorder. Please check your browser',
        autoProctor:'monitor in use',
        broswerPass: 'Broswer test pass',
        broswerSuggest: 'The latest version of Google Chrome is recommended',
        examConfirm: 'Paper confirm',
        step1: 'Step1 Check Camera',
        step2: 'Step2 Check Screen Recorder',
        examEnsure: 'Exam Rules',
        examEnsure1: '1 Non-stop exam once it starts. Time is limited',
        examEnsure2: '2 Do not quit the exam screen, you may not allow to access again',
        examEnsure3: '3 please click submit button when you complete',
        skipCheck: '您还未通过环境检测，是否直接进入考试？',
        enterExam: 'Enter',
        onGoing: 'On going',
        startTime: 'Start time',
        pleaseToLogin: 'please login first',
        ensureLeave: 'Sure you want to leave the page?',
        submitPaper: 'Submit',
        reviewPaper: 'Review paper',
        submitSuccess: 'Submit success',
        savePaper: 'Save paper',
        savePaperNow: 'Do you want to save the paper?',
        undoCount: 'You still have {undoCount} questions to answer',
        undoReviewCount: 'You still have {undoCount} questions to review',
        submitPaperNow: 'submit now? you are not allowed to visit it again',
        examFinished: 'Finished',
        jumpoutNotice: 'Quit from page may leads to exam suspended',
        jumpoutBreak: 'Exam is suspended for quiting form this page',
        sureCloseEditor: 'Do you want to close the editor?',
        sureSaveCode: 'Please sure the project is saved',
        keywords: 'Keywords:',
        gapWhich: 'The answer to the ',
        gapAnswer: 'th blank：【',
        gapOr: ' 】or【',
        comment: 'Comment',
        submitTime: 'Submit date',
        submitTimes: 'Submit times',
        continue: 'Continue',
        again: 'Again',
        toExam: 'To exam',
        onGoging: 'On going',
        saved: 'Saved',
        submitted: 'Submitted',
        corrected: 'Corrected',
        pleaseInputUsername: 'Please input username'
    },
}